module.exports = __webpack_public_path__ + "img/page.295385c.svg";